<template>
    <div>
        <div class="row justify-content-md-center">
            <div class="col-md-6">
                <b-input-group>
                    <b-form-input
                        type="text"
                        placeholder="Busca por linea"
                        v-model="search"
                        :formatter="formatter"
                    ></b-form-input>
                    <b-input-group-append>
                        <b-input-group-text>
                            <b-icon icon="search" />
                        </b-input-group-text>
                    </b-input-group-append>
                </b-input-group>
                <div class="mt-4 mb-2">
                    <div v-if="loading" style="text-align: center;">
                        <b-spinner label="Loading..."></b-spinner>
                    </div>
                    <div class="row">
                        <div
                        v-for="item in orderFilter(filteredLineas)"
                        :key="item.lineas._id"
                        class="col-md-4 col-sm-12">
                            <b-button
                            @click="set_linea(item.lineas)"
                            id="button-models" block>
                                {{ item.lineas.name }}
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {API_LINEAS, HEADERS} from 'providers/ApiCredentials';
import { mapFields } from "vuex-map-fields";
export default {
    computed: {
        ...mapFields("vender", [
            'selection_data.marca_id',
            'selection_data.modelo',
            'asistente_step',
            'titulo_span',
            'selection_data.linea_name',
            'selection_data.linea_id',
            'form_data.lineas'
        ]),
        filteredLineas: function() {
            return this.lineas.filter((data) => {
                return data.lineas.name.toLowerCase().includes(this.search.toLowerCase());
            });
        }
    },
    data() {
        return {
            loading: true,
            search: ""
        }
    },
    mounted () {
        this.get_lineas();
    },
    methods: {
        get_lineas() {
            var queryString = window.location.search;
            var urlParams = new URLSearchParams(queryString);
            var step = urlParams.get('step');

            var data = {
                id_marca: this.marca_id,
                modelo: this.modelo
            };
            axios.get("/vender_filter_step?step="+ step +"&id_marca=" + this.marca_id + "&modelo=" + this.modelo).then(response => {
                var parsingModelos = _.orderBy(
                    response.data.result.lineas,
                    ["linea.name"],
                    ["asc"]
                );
                this.lineas = parsingModelos;
                this.loading = false;
            });
            // axios.post(API_LINEAS,data, HEADERS).then(response => {
            //     var parsingLineas = _.orderBy(
            //         response.data.lineas,
            //         ["linea.name"],
            //         ["asc"]
            //     );
            //     this.lineas = parsingLineas;
            //     this.loading = false;
            // });
        },
        set_linea(linea){
            this.asistente_step = 'version';
            this.titulo_span = 'Seleccione la version'
            this.linea_name = linea.name;
            this.linea_id = linea._id;
            window.history.replaceState(null, null, '?step=4');
        },
        orderFilter(linea) {
            var orderFilter = _.orderBy(linea, 'lineas.name', ["asc"]);
            return orderFilter;
        },
        formatter(value) {
            return value.toUpperCase()
        }
    },
};
</script>

<style lang="scss"></style>
